import { FormFieldTypes } from "../../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../../components/finalForms/libs/data/ValidationTypes";

const initState = {
  lClientKey: null,
  lContractTypeKey: null,
  sContractName: "",
};
export const addPendingContractsConfig = {
  name: "AddContracts",
  initialState: initState,
  section: [
    {
      sectionId: "AddContractsSection",
      title: "Add Pending Contract",
      row: {},
      style: {
        sectionStyle: "mt-2",
      },
      rowGroup: [
        {
          groupLabel: "Pending Contact Information", 
          style: {
            groupStyle: "mb-3",
          },
          groupWrapper: <div className="row"></div>, 
          fields: [
            {
              id: "lClientKey",
              label: "Client : ",
              Field_Name: "Client",
              fieldType: FormFieldTypes.SELECT,
              dataField: "lClientKey",
              fieldSetting: {
                placeholder: "Select Client",
                options: [],
                isLoading: false,
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-7 col-md-7 col-12 mb-2",
              },
            },
            {
              id: "lContractTypeKey",
              label: "Contract Type :",
              Field_Name: "Contract Type",
              fieldType: FormFieldTypes.SELECT,
              dataField: "lContractTypeKey",
              fieldSetting: {
                placeholder: "Select Contract Type",
                isLoading: false,
                options: [],
              },
              validation: [{ type: validationTypes.REQUIRE }],
              style: {
                containerCss: "col-lg-5 col-md-5 col-12 mb-2 ",
              },
            },
            
            {
              id: "sContractName",
              label: "Contract Name :",
              Field_Name: "contract name",
              fieldType: FormFieldTypes.INPUT,
              dataField: "sContractName",
              fieldSetting: {
                placeholder: "Enter Contract Name",
                allowSpace: true,
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-12 col-md-4 col-4",
              },
            },
          ],
        },
      ],
    },
  ],
};
